import { TranslationsContext } from '@teliaee/telia-translate';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IFormHelperProps, ISelectOption, Select, TSelectValue } from 'telia-front-react';
import { useStores } from '../../../stores/RootStore';
import { helperInErrorState, TOPIC_FIELD_ID } from '../../../util/FieldHelperUtil';

type Topic = 'SERVICES' | 'BILLING' | 'SUPPORT';

const TopicSelection = observer((): React.JSX.Element => {
  const {
    callbackStore: { callbackCreation, updateReservationCreationBranchId, hasCallbackCreationFormSubmitted, getTopicHelper }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const [topicHelper, setTopicHelper] = React.useState<IFormHelperProps | undefined>(undefined);

  React.useEffect(() => {
    setTopicHelper(getTopicHelper(translate));
  }, [callbackCreation.topic, hasCallbackCreationFormSubmitted]);

  const getTopics = () => {
    return [
      {
        value: 'SERVICES',
        label: translate('reservation.requestCallback.topic.services')
      },
      {
        value: 'BILLING',
        label: translate('reservation.requestCallback.topic.billing')
      },
      {
        value: 'SUPPORT',
        label: translate('reservation.requestCallback.topic.support')
      }
    ];
  };

  const updateValue = (selectOption: ISelectOption) => {
    runInAction(() => (callbackCreation.topic = selectOption.value as Topic));
    updateReservationCreationBranchId();
  };

  return (
    <Select
      id={TOPIC_FIELD_ID}
      label={translate('reservation.requestCallback.topic')}
      value={getTopics().find((t: ISelectOption) => t.value === callbackCreation.topic) || null}
      placeholder={translate('reservation.requestCallback.topic')}
      options={getTopics()}
      onChange={(value: TSelectValue) => updateValue(value as ISelectOption)}
      isInvalid={helperInErrorState(topicHelper)}
      errorMessage={helperInErrorState(topicHelper) ? (topicHelper.text as string) : undefined}
    />
  );
});

export default TopicSelection;
